// Florals — real watercolor bougainvillea border (cropped from Bouganvillea_border.png)
// composited on the cream paper. Keeps the original FloralSpray API (variant/density/
// className) so screens need no changes; width/height/seed are accepted but unused.
import type { CSSProperties } from "react";

export type FloralVariant = "topBorder" | "cornerTL" | "cornerTR" | "sprig";
export type FloralDensity = "none" | "subtle" | "lush";

const SRC: Record<FloralVariant, string> = {
  topBorder: "/florals/border-top.webp",
  cornerTL: "/florals/corner-tl.webp",
  cornerTR: "/florals/corner-tr.webp",
  sprig: "/florals/sprig.webp",
};

const OBJECT_POSITION: Record<FloralVariant, string> = {
  topBorder: "center top",
  cornerTL: "left top",
  cornerTR: "right top",
  sprig: "center top",
};

interface FloralSprayProps {
  variant?: FloralVariant;
  density?: FloralDensity;
  width?: number; // accepted for API compatibility (unused)
  height?: number; // accepted for API compatibility (unused)
  seed?: number; // accepted for API compatibility (unused)
  style?: CSSProperties;
  className?: string;
}

export function FloralSpray({ variant = "topBorder", density = "lush", style, className = "" }: FloralSprayProps) {
  if (density === "none") return null;
  return (
    <img
      src={SRC[variant]}
      className={"floral-img " + className}
      alt=""
      aria-hidden="true"
      style={{
        objectPosition: OBJECT_POSITION[variant],
        opacity: density === "subtle" ? 0.5 : undefined,
        ...style,
      }}
    />
  );
}

// small engraved ornament divider (unchanged — this is line art, not floral)
export function Ornament({ color = "currentColor", width = 120 }: { color?: string; width?: number }) {
  return (
    <svg width={width} height="14" viewBox="0 0 120 14" style={{ display: "block" }} aria-hidden="true">
      <line x1="6" y1="7" x2="50" y2="7" stroke={color} strokeWidth="1" />
      <line x1="70" y1="7" x2="114" y2="7" stroke={color} strokeWidth="1" />
      <circle cx="60" cy="7" r="3.4" fill="none" stroke={color} strokeWidth="1" />
      <circle cx="60" cy="7" r="1.1" fill={color} />
      <circle cx="52.5" cy="7" r="1" fill={color} />
      <circle cx="67.5" cy="7" r="1" fill={color} />
    </svg>
  );
}
